<template>
  <div id="checkin-tab">
    <a-tabs v-model="tabInit" @tabClick="changeTab" type="card">
      <a-tab-pane tab="办理值机" key="1"></a-tab-pane>
      <a-tab-pane tab="补打登机牌" key="2" v-if="!['UQ', '8L'].includes(airline)"></a-tab-pane>
      <a-tab-pane tab="取消值机" key="3"></a-tab-pane>
      <a-tab-pane tab="值机记录" key="4"></a-tab-pane>
    </a-tabs>
  </div>
</template>
<style lang="less">
#checkin-tab {
  padding-top: 40px;
  .ant-tabs-bar {
    border-bottom-color: @primary-color;
  }
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
    border: 0;
    border-radius: 0;
    padding-left: 25px;
    padding-right: 25px;
    background: #fff;
    color: #808080;
    font-size: 17px;
  }
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    background: @primary-color;
    color: #fff;
    font-weight: bold;
  }

  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container {
    margin-bottom: 0;
  }
}
@media only screen and (max-width: 768px) {
  #checkin-tab {
    padding-top: 30px;
  }
}
</style>
<script>
export default {
  props: {
    tabInit: { type: String }
  },
  data () {
    return {
      airline: window.__MICRO_ROOT__?.airline
    }
  },
  methods: {
    changeTab (value) {
      let url = ''
      switch (value) {
        case '1':
          url = '/checkin'
          break
        case '2':
          url = '/boardingCard'
          break
        case '3':
          url = '/checkinCancel'
          break
        case '4':
          url = '/checkinRecrod'
          break
      }
      this.$router.push({ path: url })
    }
  }
}
</script>
